module.exports = __webpack_public_path__ + "media/images/flag_red-6ae753874f80c4a134cffee560f66d41.png";